import LoadingBox from 'components/Common/Loading/LoadingBox'
import React from 'react'
import useBusinessTravellerSocieteDetailsFetcher from 'businessTraveller/hooks/useBusinessTravellerSocieteDetailsFetcher'
import useSocieteCampaign from 'loyalty/hooks/useSocieteCampaign'
import { LEBT_SOCIETE_CAMPAIGN_SLUG } from 'loyalty/constants/loyaltyRoutes'
import { isAtOrAboveLoyaltyTier } from 'loyalty/utils/isAtOrAboveLoyaltyTier'
import SocieteCampaignGoldCardContent from './SocieteCampaignGoldCardContent'

interface Props {
  onLearnMoreClick?: () => void
}

function SocieteCampaignGoldCard(props: Props) {
  const { onLearnMoreClick } = props
  const campaign = useSocieteCampaign(LEBT_SOCIETE_CAMPAIGN_SLUG)
  const { isFetching: isFetchingSocieteDetails, societeSetting, linkedCreditAccount } = useBusinessTravellerSocieteDetailsFetcher()

  if (isFetchingSocieteDetails) {
    return <LoadingBox height={280} borderRadius="L" />
  }

  const isAtOrAboveGold = isAtOrAboveLoyaltyTier(linkedCreditAccount?.tier, 'gold')
  const isSocieteGoldEnabled = societeSetting?.value?.gold.enabled

  // Hide once the campaign is not enabled, or the user is already at Société Gold or above, or there is no campaign with a secondary section in state
  if (!isSocieteGoldEnabled || isAtOrAboveGold || !campaign) return null

  return <SocieteCampaignGoldCardContent
    campaign={campaign}
    societeSetting={societeSetting}
    linkedCreditAccount={linkedCreditAccount}
    onLearnMoreClick={onLearnMoreClick}
  />
}

export default SocieteCampaignGoldCard
